import GiftSubscriptionPage, { getServerSideProps } from '@haaretz/s-pp-giftSubscription-page';

export default GiftSubscriptionPage;

export { getServerSideProps };
